import { CountryRiskIndex, CountryRiskView } from '@grid-ui/common';
import { ItemInformationListingItemDatatype } from '../item-information-listing';
import { CommodityRiskView } from '../risk-view';

/**
 * Typeguard to determine whether the specified data for an Item Information Listing
 * contains "name" property.
 *
 * @param data An Item Information Listing item.
 */
export function isNameDatatype(data: ItemInformationListingItemDatatype): data is CountryRiskView | CountryRiskIndex | CommodityRiskView {
  return (data as any).name !== undefined;
}
